import { Grid } from "@mui/material";
import { TitledSection } from "components/Classifiers/Common/TitledSection";
import { observer } from "mobx-react";
import React from "react";
import { TestSetFields } from "../../Components/TestSetFields";
import { SyntheticDataSection } from "../../Components/SyntheticData/SyntheticDataSection";

export const LLMClassifierData = observer(() => {
    return (
        <Grid container item direction="column" flexWrap="nowrap" rowGap={2}>
            <TestSetSection />
            <SyntheticDataSection />
        </Grid>
    );
});

export const TestSetSection = observer(() => (
    <TitledSection
        title="Test set"
        subtitle="Pick the labeled conversations to hold out for final testing and to seed synthetic data."
        variant="bordered"
    >
        <TestSetFields />
    </TitledSection>
));
